import { render, staticRenderFns } from "./FileDownloadEditor.vue?vue&type=template&id=af597d9a&scoped=true"
import script from "./FileDownloadEditor.vue?vue&type=script&lang=js"
export * from "./FileDownloadEditor.vue?vue&type=script&lang=js"
import style0 from "./FileDownloadEditor.vue?vue&type=style&index=0&id=af597d9a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af597d9a",
  null
  
)

export default component.exports